import React from "react";
import "../styles/Projects.css";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";
import GitHubIcon from "@material-ui/icons/GitHub";
import OpenInBrowserIcon from "@material-ui/icons/OpenInBrowser";
import FadeInSection from "./FadeInSection";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const projects = {
      "SFI MES KC React.js project": {
        desc:
          "Official web site for sfi mes kalladi college.",
        techStack: "React.js,git,github",
        link: "https://github.com/jaseem1999/react-sfikc",
        open: "https://sfimeskc.in/"
      },
      "Rise Up": {
        desc:
          "It's web site for Rise Up .",
        techStack: "React.js/git/github",
        link: "https://github.com/jaseem1999/Rise-up/",
        open: "https://jaseem1999.github.io/Rise-up/"
      },
      "Dr. Saleej sir": {
        desc:
          "It's web site for Dr Saleej K.T .",
        techStack: "Javascript, HTML / CSS /SCSS/ Bootstrap /git,github",
        link: "https://github.com/jaseem1999/Dr_saleej_sir",
        open: "https://jaseem1999.github.io/Dr_saleej_sir/"
      },
      "Jhone hopkins university project": {
        desc:
          "Its my first project of john hopkins university .",
        techStack: "Javascript, HTML / CSS /SCSS/ Bootstrap /git,github",
        link: "https://github.com/jaseem1999/RestaurantJunaid",
        open: "https://jaseem1999.github.io/RestaurantJunaid/"
      },
      "My Netflix trailer Project of React.js": {
        desc:
           "Netflix app ",
        techStack: "React.js, API, ",
        link: "https://github.com/jaseem1999/netflixDemo",
        open: "https://jaseem1999.github.io/netflixDemo/"
      },
      "E-commerce": {
        desc:
          "E-commerce website",
        techStack: "Java/JSP/MySQL/Javascript, HTML / CSS /SCSS/ Bootstrap /git,github",
        link: "",
        open: "https://github.com/jaseem1999/E-commerce-java"
      }
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">/ software-creations</span>
        </div>

        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <FadeInSection delay={`${i + 1}00ms`}>
                <li className="projects-card">
                  <div className="card-header">
                    <div className="folder-icon">
                      <FolderOpenRoundedIcon
                        style={{ fontSize: 35 }}
                      ></FolderOpenRoundedIcon>
                    </div>
                    <span className="external-links">
                      <a className="github-icon" href={projects[key]["link"]}>
                        <GitHubIcon
                          style={{
                            fontSize: 20,
                            color: "var(--lightest-slate)"
                          }}
                        ></GitHubIcon>
                      </a>
                      {projects[key]["open"] && (
                        <a className="open-icon" href={projects[key]["open"]}>
                          <OpenInBrowserIcon
                            style={{
                              fontSize: 25,
                              color: "var(--lightest-slate)"
                            }}
                          ></OpenInBrowserIcon>
                        </a>
                      )}
                    </span>
                  </div>

                  <div className="card-title">{key}</div>
                  <div className="card-desc">{projects[key]["desc"]}</div>
                  <div className="card-tech">{projects[key]["techStack"]}</div>
                </li>
              </FadeInSection>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Projects;
